import { MARKETING_PAGE_SEO_TITLE_MAXLENGTH_MESSAGE } from '@modules/whitelabel-cover-page/marketing-page-section/marketing-page-section.constants';

export const WHITELABEL_COVER_PAGE_TYPE = 'WLS_COVER_PAGE' as const;
export const COVER_PAGE_IMAGE_FILE_PREFIX = 'wls_' as const;
export const WHITELABEL_COVER_PAGE_URL = 'wls_cover_page' as const;
export const WHITELABEL_COVER_PAGE_TITLE = 'White Label Cover Page';

export const WHITELABEL_COVER_PAGE_API = {
  ACTIONS: {
    CREATE_PAGE: 'create_page',
    UPDATE_PAGE: 'update_page',
    CREATE_SECTION: 'create_section',
    UPDATE_SECTION: 'update_section',
    DELETE_SECTION: 'delete_section',
    REORDER_SECTIONS: 'reorder_sections',
    DELETE_PAGE: 'delete_page'
  },
  FIELDS: {
    ACTION: 'action',
    PK: 'pk',
    SK: 'sk',
    CREATOR_ID: 'creator_id',
    PAGE_ID: 'page_id',
    TITLE: 'title',
    STATUS: 'status',
    META_TITLE: 'meta_title',
    META_DESCRIPTION: 'meta_description',
    SEO_KEYWORDS: 'seoKeywords',
    LAYOUT_ID: 'layout_id',
    SECTION_TYPE: 'section_type',
    SECTION_ID: 'section_id',
    SEQUENCE_NUMBER: 'sequence_number',
    IS_VISIBLE: 'is_visible',
    SECTIONS: 'sections',
    CREATED_AT: 'created_at',
    UPDATED_AT: 'updated_at',
    BACKGROUND_COLOR: 'background_color',
    TEXT_COLOR: 'text_color',
    SECONDARY_BACKGROUND_COLOR: 'secondary_background_color',
    POST_TEXT_COLOR: 'post_text_color',
    BACKGROUND_TEXT_COLOR: 'background_text_color',
    BUTTON_TEXT_COLOR: 'button_text_color',
    COMPETITOR_LOGO: 'competitor_logo'
  }
} as const;

export const WHITELABEL_COVER_PAGE_CONSTANTS = {
  PAGE_TITLE: WHITELABEL_COVER_PAGE_TITLE,
  EDIT_PAGE: 'BACK TO WHITE LABEL SETTINGS',
  PREVIEW: 'PREVIEW',
  PUBLISH: 'PUBLISH',
  DRAFT_BUTTON_LABEL: 'DRAFT',
  CANCEL: 'CANCEL',
  ADD_PAGE: 'ADD PAGE',
  UPDATE: 'UPDATE',
  UPDATE_AND_PUBLISH: 'UPDATE & PUBLISH',
  UPDATE_AND_DRAFT: 'UPDATE & DRAFT',
  STATUS_PUBLISHED: 'PUBLISHED',
  STATUS_DRAFT: 'DRAFT',
  PAGE_UPDATED_SUCCESSFULLY: 'Page updated successfully',
  PAGE_DRAFTED_SUCCESSFULLY: 'Page Drafted Successfully',
  PAGE_PUBLISHED_SUCCESSFULLY: 'Page published successfully',
  SECTION_CREATED_SUCCESSFULLY: 'Section created successfully',
  SECTION_UPDATED_SUCCESSFULLY: 'Section updated successfully',
  SECTION_DELETED_SUCCESSFULLY: 'Section deleted successfully',
  SECTION_REORDERED_SUCCESSFULLY: 'Sections reordered successfully',
  SECTION_VISIBLE_SUCCESSFULLY: 'Section is now visible',
  SECTION_HIDDEN_SUCCESSFULLY: 'Section is now hidden',
  PAGE_LOAD_FAILED: 'Unable to load the cover page',
  PAGE_SAVE_FAILED: 'Unable to save the cover page',
  SEO_SAVE_FAILED: 'Unable to save SEO metadata',
  SECTION_SAVE_FAILED: 'Unable to save the section',
  SECTION_DELETE_FAILED: 'Unable to delete the section',
  SECTION_REORDER_FAILED: 'Unable to reorder the sections',
  LOCKED_SECTION_DELETE_ERROR: 'Header and Footer sections cannot be deleted',
  LOCKED_SECTION_REORDER_ERROR: 'Header must stay first and Footer must stay last',
  SOMETHING_WENT_WRONG: 'Something went wrong',
  FORM_LABEL_SEO_TITLE: 'Cover Page SEO Title',
  FORM_PLACEHOLDER_SEO_TITLE: 'Add a title for the White Label Cover Page.',
  FORM_LABEL_SEO_KEYWORDS: 'Cover Page SEO Keywords (Separated by commas)',
  FORM_PLACEHOLDER_SEO_KEYWORDS: 'Add up to 20 keywords separated by commas.',
  FORM_LABEL_SEO_DESCRIPTION: 'Cover Page SEO Description',
  FORM_PLACEHOLDER_SEO_DESCRIPTION: 'Enter SEO Description',
  FORM_VALIDATION_SEO_TITLE_REQUIRED: 'SEO Title is required',
  FORM_VALIDATION_SEO_TITLE_MAXLENGTH: MARKETING_PAGE_SEO_TITLE_MAXLENGTH_MESSAGE,
  FORM_VALIDATION_SEO_KEYWORDS_REQUIRED: 'SEO Keywords is required',
  FORM_VALIDATION_SEO_KEYWORDS_PATTERN: 'Only 20 keywords are allowed',
  FORM_VALIDATION_SEO_DESCRIPTION_REQUIRED: 'SEO Description is required',
  FORM_VALIDATION_SEO_DESCRIPTION_MAXLENGTH: 'Maximum 1000 characters are allowed'
} as const;

export const WLS_COVER_PAGE_UPDATING_MODAL = {
  HEADER: 'White Label Site Cover Page Updating',
  READY_BY_PREFIX: 'The changes to your white label cover page will be ready by',
  VIEW_MY_SITE_BTN: 'View My Site',
  DATE_FORMAT: 'MMM d, yyyy, h:mm a'
} as const;

export const WHITELABEL_COVER_PAGE_FULL_PREVIEW_CONSTANTS = {
  NO_SECTIONS_TO_PREVIEW:
    'No sections to preview. Add sections or use Full Preview from a section editor.',
  FULL_PREVIEW: 'PREVIEW COVER PAGE',
  FULL_PREVIEW_RETURN_URL_STATE_KEY: 'fullPreviewReturnUrl',
  PAGE_COMPETITOR_LOGO_STATE_KEY: 'pageCompetitorLogo',
  DESKTOP: 'Desktop',
  MOBILE: 'Mobile',
  VIEWPORT: {
    DESKTOP: 'desktop',
    MOBILE: 'mobile'
  }
} as const;

export const WHITELABEL_COVER_PAGE_PREVIEW_MODES = {
  PREVIEW: 'preview',
  PUBLIC: 'public'
} as const;

export type WhitelabelCoverPagePreviewViewport =
  (typeof WHITELABEL_COVER_PAGE_FULL_PREVIEW_CONSTANTS.VIEWPORT)[keyof typeof WHITELABEL_COVER_PAGE_FULL_PREVIEW_CONSTANTS.VIEWPORT];

export type WhitelabelCoverPagePreviewMode =
  (typeof WHITELABEL_COVER_PAGE_PREVIEW_MODES)[keyof typeof WHITELABEL_COVER_PAGE_PREVIEW_MODES];
